import { render } from "./DownloadInvoiceBtn.vue?vue&type=template&id=621acbba"
import script from "./DownloadInvoiceBtn.vue?vue&type=script&lang=js"
export * from "./DownloadInvoiceBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__